import { useCallback } from 'react';

import { UserActionType } from '@kaltura-ott/tvpil-analytics';

import { useRailContext } from 'components/widgets/Rail/components/RailProvider/RailProvider';
import { useStableReactRouter } from 'context/stableReactRouterContext/stableReactRouterContext';
import { resolvePathToDetailsPageV2, userActionEvents } from 'utils';

interface Props {
  id: number;
  mediaTypeParam: string;
  externalId: string | undefined;
  channelHasProgram: boolean;
  imageHeight: number;
  isLinkAsAsset: boolean;
}

export const useCollectionCardHandleClickInfo = ({
  id,
  imageHeight,
  mediaTypeParam,
  externalId,
  channelHasProgram,
  isLinkAsAsset,
}: Props) => {
  const { navigate, location } = useStableReactRouter();
  const { onCardClick } = useRailContext();
  const { state } = location;

  // handle click info button on hero card to navigate to details page
  const handleClickInfo = useCallback(
    (e: React.MouseEvent) => {
      if (!channelHasProgram || isLinkAsAsset) {
        return;
      }

      e.preventDefault();
      e.stopPropagation();

      if (onCardClick) {
        onCardClick(id);
      }

      userActionEvents(UserActionType.details, id, mediaTypeParam);

      const link = resolvePathToDetailsPageV2({
        id,
        mediaTypeParam,
        externalId,
      });

      navigate(link, {
        state: {
          goBackUrl: state?.goBackUrl,
          lastScrollYPosition: window.scrollY + imageHeight,
        },
      });
    },
    [id],
  );

  return { handleClickInfo };
};
